import { darken } from "@mui/material";

const MuiMenu = {
  styleOverrides: {
    paper : ({theme} : any) => ({
      border: `2px solid ${darken(theme.palette.background.default,0.2)}`,
      borderRadius: 12,
      boxShadow: 'none',
    }),
  },
};

export default MuiMenu;
